var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'loading-container': true,
    loading: _vm.isLoading,
    visible: _vm.isVisible,
  }},[_c('div',{staticClass:"loader",style:({ width: _vm.progress + '%' })},[_c('div',{staticClass:"light"})]),_c('div',{staticClass:"glow"})])}
var staticRenderFns = []

export { render, staticRenderFns }